import http from '@/plugs/httpServer';
import { serverName } from '@wj/common';
let feather_campus= "feather-campus"

// 根据itineraryId获取当前行程下的岗位列表
export function getScheduleJobList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/job/listJob`,
        data: data,
    })
}
// 根据全部岗位列表
export function getAllJobList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/job/getAllJobs`,
        data: data,
    })
}


